import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// View-split styles (mobile-first order)
import './styles/base.css';
import './styles/max-900.css';
import './styles/max-600.css';
import './styles/max-425.css';
import './styles/min-1024.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
